import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { useTranslator } from '@jutro/locale';
import { Badge } from '@jutro/components';

import { commonQuoteStyles } from 'gw-capability-quoteandbind-common-react';

import messages from './EuQuoteInfo.messages';

function renderVehicles(submissionVM, vehicles = []) {
    return vehicles
        .map(({ displayName, vin }) => {
            const textToDisplay = `${displayName} (${vin})`;

            return (
                <span className={commonQuoteStyles.coverableItem} key={vin}>{textToDisplay}</span>
            );
        });
}

function renderDrivers(submissionVM, drivers = []) {
    return drivers
        .map(({ person }) => {
            const { displayName } = person;

            return (
                <span
                    key={displayName}
                    className={commonQuoteStyles.coverableItem}
                >
                    {displayName}
                </span>
            );
        });
}

/**
 * Renders a badge if the colection contains more than 1 item
 * @param {Array} collection an array of items
 * @returns {React.ReactNode}
 */
function renderBadge(collection) {
    const size = _.get(collection, 'length', 0);

    if (size > 1) {
        return (
            <Badge
                type="inverse"
                size="small"
                value={size}
                className={commonQuoteStyles.infoBlockBadge}
            />
        );
    }

    return null;
}

function EuQuoteInfo(props) {
    const { submissionVM } = props;
    const translator = useTranslator();
    const quoteId = _.get(submissionVM, 'quoteID.value');
    const vehicles = _.get(submissionVM, 'lobData.personalUmbrella_EU.coverables.vehicles.value', [])
        .filter(({ displayName }) => !_.isEmpty(displayName));
    const drivers = _.get(submissionVM, 'lobData.personalUmbrella_EU.coverables.drivers.value', [])
        .filter(({ person }) => !_.isEmpty(person.displayName));

    const address = _.get(submissionVM, 'baseData.policyAddress.value', {});
    const { displayName = '' } = address;

    const policyAddressToShowInHeader = displayName;

    return (
        <div className={commonQuoteStyles.quoteInfoBar}>
            <div className={commonQuoteStyles.infoBlock}>
                <div className={commonQuoteStyles.infoBlockTitle}>
                    {translator(messages.personalUmbrella_EUQuote)}
                </div>
                <div id="contextSubmissionId" className={commonQuoteStyles.infoBlockContent}>{quoteId}</div>
            </div>
            <div className={commonQuoteStyles.infoBlock}>
                <div className={commonQuoteStyles.infoBlockTitle}>
                    {translator(messages.location)}
                </div>
                <div id="contextLocation" className={commonQuoteStyles.infoBlockContent}>{policyAddressToShowInHeader}</div>
            </div>
            <div className={commonQuoteStyles.infoBlock}>
                <div className={commonQuoteStyles.infoBlockTitle}>
                    {translator(messages.vehicles)}
                    {renderBadge(vehicles)}
                </div>
                <div id="vehicles" className={commonQuoteStyles.infoBlockContent}>{renderVehicles(submissionVM, vehicles)}</div>
            </div>
            <div className={commonQuoteStyles.infoBlock}>
                <div className={commonQuoteStyles.infoBlockTitle}>
                    {translator(messages.drivers)}
                    {renderBadge(drivers)}
                </div>
                <div id="drivers" className={commonQuoteStyles.infoBlockContent}>{renderDrivers(submissionVM, drivers)}</div>
            </div>
        </div>
    );
}

EuQuoteInfo.propTypes = {
    submissionVM: PropTypes.shape({}).isRequired,
};

export default EuQuoteInfo;
